<template>
  <div class="conf-wrapper">
    <div v-if="appointmentDetails.appointment.current_status == 1 && !showError">
           <div
            class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
            id="page-login"
          >
            <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
              <b-card>
                <h4>{{ $t("MeetingIsFinished") }}</h4>
              </b-card>
            </div>
          </div>
        </div>
        <div v-else>
    <audio src="@/assets/audio/speech.mp3" id="backgroundAudio" muted />
    <div v-if="!showPayButton && appointmentDetails.staff_entered != false">
      <div v-if="!showError" id="meet" class="w-full confroom"></div>
      <div
        v-if="showError"
        class="h-screen flex w-full bg-img vx-row no-gutter items-center justify"
        id="page-login"
      >
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
          <b-card>
            <h4>{{ $t("RoomError") }}</h4>
          </b-card>
        </div>
      </div>
    </div>
    <div v-if="showPayButton">
      <div
        class="h-screen flex w-full bg-img vx-row no-gutter items justify"
        id="page-login"
      >
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
          <b-card>
            <h5>{{ $t("PaymentMsg") }}</h5>
            <p>
              <b-button
                    type="filled"
                    variant="primary"
                    class="mt-5"
                    @click="payForm()"
                    >{{ $t("PayNow") }}</b-button
                  >
            </p>
          </b-card>
        </div>
      </div>
    </div>
    <b-card class="mt-10" v-if="appointmentDetails.staff_entered == false">
      <div>
        <div class="profile-header app-details">
          <div class="relative">
            <div class="pointer-events-none">
              <div>
                <!-- <vs-avatar
                  class="user-profile-img img-center"
                  :src="appointmentDetails.appointment.company_profile_image"
                  size="85px"
                /> -->
                  <b-avatar
                      class="img-center"
                      :src="
                        appointmentDetails.appointment.company_profile_image
                      "
                      size="350px"
                    ></b-avatar>
              </div>
            </div>
            <div class="company-center mt-5">
              <h4 class="mt-2">{{ $t("Welcome1") }}</h4>
              <p class="mt-2">
                <span v-if="!appointmentDetails.appointment.many_to_many">
                  {{ $t("AppointmentBookedText2") }}</span
                >
                <b>{{ appointmentDetails.appointment.staff_name + " " }}</b
                ><span v-if="appointmentDetails.appointment.many_to_many"
                  >event</span
                >
                {{ $t("ScheduleAt") }}
                <br />
              </p>
              <p class="mt-2" style="text-transform: capitalize">
                <i class="feather icon-calendar mr-2"></i>
                {{ appointmentDetails.appointment.start_time }} -
                {{ appointmentDetails.appointment.end_time }}, {{ showDate }}
              </p>
              <p class="mt-2" style="text-transform: capitalize">
                <i class="feather icon-phone mr-2"></i>
                {{ appointmentDetails.appointment.company_contact }}
              </p>
            </div>

            <div class="appointment-details mt-10" v-if="!is_rescheduled">
              <div
                class="department-list"
                v-if="appointmentDetails.appointment.type != 'walkin'"
              >
                <h5 class="user">{{ $t("UserNotConnect") }}</h5>
              </div>
              <div
                class="department-list"
                v-if="
                  !showNotConnect &&
                  appointmentDetails.appointment.type == 'walkin'
                "
              >
                <h5 class="user">{{ $t("WalkinsMeetingText") }}</h5>
                <h5 class="user mt-2">{{ timer }}</h5>
              </div>
              <div class="department-list" v-if="showNotConnect">
                <h5 class="user">{{ $t("WalkinsMeetingNotConnect") }}</h5>
                <h5 class="user mt-2">
                  <a :href="redirect">{{ $t("ScheduleMeeting") }}</a>
                </h5>
              </div>
            </div>
            <div class="appointment-details mt-10" v-if="is_rescheduled">
              <div class="department-list">
                <h5 class="user mt-2">{{ $t("AlreadyScheduleMeeting") }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-card>
  </div>
  </div>
</template>
<style scoped>
/* .confhub .router-view {
  padding: 0px !important;
} */

.confhub .navbar-floating .router-content {
  margin-top: 0px !important;
}

.confroom {
  display: block; /* iframes are inline by default */
  background: rgb(179, 177, 177);
  border: none; /* Reset default border */
  height: 100vh; /* Viewport-relative units */
  width: 100vw;
}

.company-center .text {
  border-bottom: #7367f0 1px dotted;
}

.app-details .img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.app-details .company-center {
  text-align: center;
}

.pay-now {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.success {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.user {
  text-align: center;
}
</style>
<script>
import moment from "moment";
import $ from "jquery";
import { getUserAppUuid, getAppUuid } from "@/utils/helper";
import Cookies from "js-cookie";
import { Validator } from "vee-validate";

export default {
  data() {
    return {
      room: "",
      userInfo: {},
      showError: false,
      userId: "",
      showPayButton: false,
      uuid: "",
      appointmentDetails: [],
      showDate: new Date(),
      alreadyJoined: false,
      markedPresece: false,
      videoConf: [],
      conference_uuid: null,
      timer: "0 : 0",
      showNotConnect: false,
      updateMissedCallFlag: true,
      is_rescheduled: null,
      interval: null,
      timeSaved : false,
      waitingTime: null
    };
  },

  computed: {
    redirect() {
       Cookies.remove("appointment_id_reschedule");
       Cookies.set("appointment_id_reschedule", this.appointmentDetails.appointment.id);

      if (this.appointmentDetails.appointment.is_premium == 0) {
        if (
          this.appointmentDetails.room_domain_and_engine.company_url == null ||
          this.appointmentDetails.room_domain_and_engine.company_url == ""
        ) {
          return "/" + this.appointmentDetails.appointment.company_slug;
        } else {
          return this.appointmentDetails.room_domain_and_engine.company_url;
        }
      } else {
        var key = btoa(
          "1&" + this.appointmentDetails.appointment.department_slug
        );
        if (
          this.appointmentDetails.room_domain_and_engine.company_url == null ||
          this.appointmentDetails.room_domain_and_engine.company_url == ""
        ) {
          return (
            "/" +
            this.appointmentDetails.appointment.company_slug +
            "/direct/" +
            this.appointmentDetails.appointment.department_slug +
            "/reschedule"
          );
        } else {
          return (  
            this.appointmentDetails.room_domain_and_engine.company_url+'?key=' +
            key
          );
        }
      }
    },
  },

  mounted() {
    // load script
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("src", "https://meet.jit.si/external_api.js");
    document.head.appendChild(recaptchaScript);

    if (this.$store.getters.currentUser.id) {
      this.loadLocale(this.$i18n.locale);
      this.userId = this.$store.getters.currentUser.id;
      this.userInfo = {
        email: this.$store.getters.currentUser.email,
        displayName:
          this.$store.getters.currentUser.first_name +
          " " +
          this.$store.getters.currentUser.last_name,
      };
    } else {
      this.userInfo = {
        displayName: "User",
      };
    }

    if ($("#room-name").val() != undefined) {
      this.room = $("#room-name").val();
    } else {
      this.room = this.$route.params.room;
    }

    // get uuid
    if (this.$route.query.key) {
      var splitData = atob(this.$route.query.key);
      splitData = splitData.split("&");
      console.log("splitData", splitData);
      this.conference_uuid = splitData[0];
      this.uuid = splitData[1];
    } else {
      this.conference_uuid = getUserAppUuid();
      this.uuid = getAppUuid();
    }

    this.checkRoom();
    console.log("staffConnected" + this.conference_uuid);
    Echo.channel("staffConnected" + this.conference_uuid).listen(
      "StaffConnected",
      (response) => {
        setTimeout(() => {
          $("#backgroundAudio")[0].play();
          setTimeout(() => {
            $("#backgroundAudio")[0].pause();
          }, 2000);
        }, 1000);
        console.log(this.alreadyJoined);
        // if already not joined
        if (this.alreadyJoined == false) {
          this.checkRoom("");
          clearInterval(this.interval);
        }
      }
    );

    Echo.channel("staffDisconnected" + this.conference_uuid).listen(
      "StaffDisconnected",
      (response) => {
      if (this.$route.name == "conference") {
        this.checkRoom("stop");
        clearInterval(this.interval);
        let data = {
            appointment_id: this.appointmentDetails.appointment.id,
            user_conference_status: "left",
            fireEvent: true
          };
          this.$store.dispatch("userAvailableUnavalibleEvent", data);
        }
      }
    );

    // call staff available event
    Echo.join("staffAvailable")
      .leaving((id) => {
          console.log('left staff',id);
          this.staffLeftRoom(id);
    });
  },
  created() {
    window.addEventListener("beforeunload", (e) => {
      e.preventDefault();
      e.returnValue = "";

      let dataVal = {
            appointment_id: this.appointmentDetails.appointment.id,
            user_conference_status: "left",
            fireEvent: true
          }
          this.$store.dispatch("userAvailableUnavalibleEvent", dataVal)
          
      var data = {
        appointment_id: this.appointmentDetails.appointment.id,
        user_id: this.appointmentDetails.appointment.user_id,
        user_role: "user",
      };
      this.$store
        .dispatch("LeftRoom", data)
        .then((res) => {})
        .catch((error) => {
          return false;
        });
    });
  },
  methods: {
     getSettings() {
      this.$store
        .dispatch("GetSystemSettings")
        .then((res) => {
          $(".bg-img").css(
            "background-image",
            "url(" + res.data.data.background_image.path + ")"
          );
        })
        .catch((error) => {
          this.$log.error(
            "File : getSetting.vue | Function : getSettings() | Error :",
            error
          );
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: this.$t("Error"),
            text:
              this.$t(error.replace(/[\s\/]/g, "")) !==
              error.replace(/[\s\/]/g, "")
                ? this.$t(error.replace(/[\s\/]/g, ""))
                : error,
            color: "danger",
            position: "top-center",
          });
          return false;
        });
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     * check room availablity
     */
    checkRoom(type) {
      this.$vs.loading();
      var data = {
        room_name: this.room,
        user_id: this.userId,
        user_role: "user",
        uuid: this.uuid,
      };
      this.$store
        .dispatch("CheckRoom", data)
        .then((res) => {
          this.$vs.loading.close();
          this.appointmentDetails = res.data.data;
          this.getSettings()
          this.videoConf = this.appointmentDetails.room_domain_and_engine;
          this.is_rescheduled = res.data.data.is_rescheduled;
          this.appointmentDetails.appointment.start_time = moment(
            this.appointmentDetails.appointment.start_time,
            "hh:mm A"
          ).format("hh:mm A");
          this.appointmentDetails.appointment.end_time = moment(
            this.appointmentDetails.appointment.end_time,
            "hh:mm A"
          ).format("hh:mm A");
          moment.locale(this.$i18n.locale);
          this.showDate = moment(
            this.appointmentDetails.appointment.date,
            "YYYY-MM-DD"
          ).format("dddd, MMMM D, YYYY");

          // setInterval(this.setReminder(), (1000*60)*5 );
          if (this.appointmentDetails.staff_entered == false &&
            this.appointmentDetails.appointment.type != "walkin") {
            setInterval(this.setReminder(), 1000 * 60 * 5);
            clearInterval(this.interval);
          } else if (this.appointmentDetails.appointment.type == "walkin" &&
            type == "stop") {
            this.leftRoom();
            this.$router.push({ path: "/" });
            clearInterval(this.interval);
          }else if (
              this.appointmentDetails.appointment.type == "one-to-one" &&
              type == "stop"
            ) {
              this.leftRoom();
              this.$router.push({ path: "/" });
              clearInterval(this.interval);
            } else if (this.appointmentDetails.appointment.is_missed_call == 1) {
            this.showNotConnect = true;
            clearInterval(this.interval);
          } else if (this.appointmentDetails.staff_entered == false &&
            this.appointmentDetails.appointment.type == "walkin") {
            this.timer = "0 : 0";
            var totalSeconds = 0;
            this.timeSaved = false;
            this.interval = setInterval(() => {
              let app_id = this.appointmentDetails.appointment.id;
              if (!localStorage.getItem(app_id)) {
                localStorage.setItem(app_id, new Date());
              }
              var d2 = new Date(localStorage.getItem(app_id));
              var d = new Date(); //get current time
              var seconds = Math.round(Math.floor(d - d2) / 1000);
              var fiveMin = 60 * 5; //five minutes is 300 seconds!
              var timeleft = fiveMin - seconds; // let's say now is 01:30, then current seconds is 60+30 = 90. And 90%300 = 90, finally 300-90 = 210. That's the time left!
              var min = "0" + parseInt(timeleft / 60);
              var sec = timeleft % 60;
              ++totalSeconds;
              this.waitingTime = this.pad(parseInt(seconds / 60)) + ':' + (this.pad((seconds + 4) % 60) );

              if(sec <= 9) {
                sec = "0" + sec;
              }
              var result =  min + " : " + sec; //formart seconds back into mm:ss
              this.timer = result;
              if (this.timer == "00 : 01" || timeleft <= 0) {
                this.showNotConnect = true;
                this.updateMissedCallApi();
                localStorage.removeItem(app_id);
                clearInterval(this.interval);
              }
              if(!this.timeSaved) {
                this.saveWaitingTime(this.appointmentDetails.appointment.id,this.waitingTime);
                this.timeSaved = true
              }
            }, 1000); //calling it every 0.5 second to do a count down
          }

          this.appointmentDetails.appointment.start_time = moment(
            this.appointmentDetails.appointment.start_time,
            "hh:mm A"
          ).format("hh:mm A");
          this.appointmentDetails.appointment.end_time = moment(
            this.appointmentDetails.appointment.end_time,
            "hh:mm A"
          ).format("hh:mm A");
          moment.locale(this.$i18n.locale);
          this.showDate = moment(
            this.appointmentDetails.appointment.date,
            "YYYY-MM-DD"
          ).format("dddd, MMMM D, YYYY");

          if (
            res.data.data.is_premium &&
            res.data.data.payment_status != 1 &&
            res.data.data.is_rescheduled != 1
          ) {
            this.showPayButton = true;
          } else {
            if (res.data.data.is_available) {
              if (this.appointmentDetails.staff_entered != false) {
                setTimeout(() => {
                  this.initConf();
                  this.showNotConnect = false;
                  clearInterval(this.interval);
                }, 1000);
              }
              // mark presence
              if (!this.markedPresece) this.joinRoom();
            } else {
              this.showError = true;
              this.$vs.notify({
                title: "Error",
                text: "Room not available",
                color: "danger",
                position: "top-center",
              });
            }

            if (this.appointmentDetails.can_join) this.joinRoom();
              else {
                this.showError = true;

                this.show = false;
                // Error response
                this.error = this.$t("RoomError1");
                this.$toasted.show(this.error, {
                  className: "top-alert",
                  position: "top-center",
                  type: "error",
                  duration: 2000,
                });
              }
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : Conference.vue | Function : checkRoom() | Error :",
            error
          );
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Room not available",
            text: error,
            color: "danger",
            position: "top-center",
          });
          return false;
        });
    },

    /**
     * waiting time cal
     */
    pad(val) {
      var valString = val + "";
      if (valString.length < 2) {
        return "0" + valString;
      } else {
        return valString;
      }
    },

     /**
     * save waiting time
     */
    saveWaitingTime(id,time) {
      var timeData = {
        appointment_id: id,
        waiting_time: time,
      };

      this.$store
        .dispatch("SetWaitingTime", timeData)
        .then((res) => {})
        .catch((error) => {
          this.$log.error(
            "File : Conference.vue | Function : saveWaitingTime() | Error :",
            error
          );
          return false;
        });
    },

    /**
     *  submitForm method for submiting form
     **/
    initConf() {
      if (!$("#meet").html()) {
        const domain = this.videoConf.room_domain;
        const options = {
          roomName: this.room,
          parentNode: document.querySelector("#meet"),
          userInfo: this.userInfo,
          interfaceConfigOverwrite: {
            MOBILE_APP_PROMO: true,
          },
        };

        const api = new JitsiMeetExternalAPI(domain, options);

        // When user left
        api.on("participantLeft", (res) => {
          this.alreadyJoined = false;
          this.leftRoom();
        });
        // When user joined
        api.on("participantJoined", (res) => {
          this.alreadyJoined = true;
          if (!this.markedPresece) this.joinRoom();
        });

        api.on("readyToClose", () => {
          this.$router.push({ path: "/" });
        });

        api.on("videoConferenceJoined", (res) => {
          let data = {
            appointment_id: this.appointmentDetails.appointment.id,
            user_conference_status: "join",
            fireEvent: true
          }
          this.$store.dispatch("userAvailableUnavalibleEvent", data)
        });
        
        api.on("videoConferenceLeft", (res) => {
          let data = {
            appointment_id: this.appointmentDetails.appointment.id,
            user_conference_status: "left",
            fireEvent: true
          }
          setTimeout(() => {
          this.$store.dispatch("userAvailableUnavalibleEvent", data)
          }, 1000)

        });

        if(this.appointmentDetails.appointment.is_pin == 0){
          // set new password for channel
          const pin = this.appointmentDetails.appointment.room_pin;
          api.addEventListener("participantRoleChanged", function (event) {
            if (event.role == 'moderator')
            api.executeCommand("password", pin);
          });

          // join a protected channel
          api.on("passwordRequired", function () {
            api.executeCommand("password", pin);
          });
        }
      }
    },
    /**
     * staff joined room
     */
    joinRoom() {
      var data = {
        appointment_id: this.appointmentDetails.appointment.id,
        user_id: this.appointmentDetails.appointment.user_id,
        user_role: "user",
      };
      this.$store
        .dispatch("JoinRoom", data)
        .then((res) => {
          this.markedPresece = true;
          let data = {
            appointment_id: this.appointmentDetails.appointment.id,
            user_conference_status: "join"
          }
          this.$store.dispatch("userAvailableUnavalibleEvent", data)
        })
        .catch((error) => {
          return false;
        });
    },

    /**
     * staff joined room
     */
    setReminder() {
      var data = {
        appointment_id: this.appointmentDetails.appointment.id,
      };
      this.$store
        .dispatch("SetReminder", data)
        .then((res) => {
          "response", res;
        })
        .catch((error) => {
          return false;
        });
    },
    /**
     * left room
     */
    leftRoom() {
      var data = {
        appointment_id: this.appointmentDetails.appointment.id,
        user_id: this.appointmentDetails.appointment.user_id,
        user_role: "user",
      };
      this.$store
        .dispatch("LeftRoom", data)
        .then((res) => {
          clearInterval(this.interval);

          let data = {
            appointment_id: this.appointmentDetails.appointment.id,
            user_conference_status: "left"
          }
          this.$store.dispatch("userAvailableUnavalibleEvent", data)
          
        })
        .catch((error) => {
          return false;
        });
    },

    /**
     * redirect to payment page
     */
    payForm() {
      let routeData = this.$router.resolve({
        path: "/appointmentpay/" + this.uuid,
      });
      window.open(routeData.href, "_blank");
    },

    /**
     * Update Missed call Flag
     */
    updateMissedCallApi() {
      if (this.updateMissedCallFlag) {
        var data = {
          appointment_id: this.appointmentDetails.appointment.id,
          is_missed_call: 1,
        };
        this.$store
          .dispatch("UpdateMissedCallFlag", data)
          .then((res) => {
            this.updateMissedCallFlag = false;
          })
          .catch((error) => {
            return false;
          });
      }
    },
    /**
     * left room
     */
    staffLeftRoom(id) {
      var data = {
        appointment_id: this.appointmentDetails.appointment.id,
        user_id: id,
        user_role: "staff",
      };
      this.$store
        .dispatch("LeftRoom", data)
        .then((res) => {})
        .catch((error) => {
          return false;
        });
    },
  },
};
</script>